<template>
  <div class="section-title">
    <div class="section-title-icon">
      <button @click="voltar">
        <i class="icofont-reply"></i>
        <span>Voltar</span>
      </button>
    </div>
    <div class="section-title-info">
      <h4>{{ title }}</h4>
      <p>{{ description }}</p>
    </div>
    <div class="section-title-btn-help">
      <ModalInfo v-if="modalDocument" :modalDocument="modalDocument" />
      <modal-informacao
        v-if="enabledModalInformacao"
        :text="textModalInformacao"
        :isIframe="enabledIframeModalInformacao"
        :urlIframe="urlIframeModalInformacao"
        :pageIdentifier="pageIdentifier"
        :enableBadge="enableBadgeModalInformacao"
        :badgeValue="badgeValueModalInformacao"
        @badge-clicked="$emit('badge-modal-informacao-clicked', $event)"
        :keyAjuda="keyAjudaModalInformacao"
      ></modal-informacao>
      <div v-else class="section-title-btn-help-placeholder"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ModalAjuda from './ModalAjuda'
import ModalInfo from './ModalInfo'
import ModalInformacao from '@/components/ModalInformacao.vue'

export default {
  name: 'SectionTitle',
  components: {
    ModalAjuda,
    ModalInfo,
    ModalInformacao,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    items: {
      type: Array,
      default: () => {},
    },
    linkvideoajuda: {
      type: String,
      default: '',
    },
    modalDocument: {
      type: String,
      default: '',
    },
    enabledModalInformacao: {
      type: Boolean,
      default: false,
    },
    textModalInformacao: {
      type: String,
      default: '',
    },
    enabledIframeModalInformacao: {
      type: Boolean,
      default: false,
    },
    urlIframeModalInformacao: {
      type: String,
      default: '',
    },
    pageIdentifier: {
      type: String,
      default: '',
    },
    enableBadgeModalInformacao: {
      type: Boolean,
      default: false,
    },
    badgeValueModalInformacao: {
      type: [String, Number],
      default: 1,
    },
    keyAjudaModalInformacao: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    voltar() {
      if (this.url && this.url !== '') {
        this.$router.push(this.url)
      } else {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style>
.section-title {
  background-color: #e9ecef;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 15px;
  padding: 0 15px;
  border-radius: 15px;
}

.section-title-icon button i {
  color: #fff;
  font-size: 15px;
  margin-right: 3px;
}

.section-title-info {
  /* flex: 0 0 80%; */
  text-align: center;
}

.section-title-btn-help {
  /* flex: 0 0 9%; */
}

.section-title-icon button {
  height: 35px;
  width: 100%;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  font-size: 12px;
  padding: 0 10px;
  border: 1px solid transparent;
}

.section-title-info h4 {
  margin-bottom: -2px;
  margin-top: 10px;
  font-weight: 600;
}

.section-title-btn-help button {
  height: 35px;
  width: 100%;
  border-radius: 32px;
  display: inline-block;
  background-color: #0fafd7;
  color: #fff;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  margin-top: 0;
  font-size: 14px;
  border: 1px solid transparent;
}

.section-title-btn-help button i {
  font-size: 14px;
  color: #fff;
}

.section-title-btn-help-placeholder {
  width: 35px;
  height: 35px;
}

@media screen and (max-width: 656px) {
  .section-title-icon button,
  .section-title.section-title-internal .section-title-icon button {
    font-size: 10px;
  }
  .section-title-info h4 {
    font-size: 16px;
    text-align: center;
  }
  .section-title-info p {
    font-size: 12px;
    text-align: center;
  }
  .section-title-icon button span {
    display: none;
  }
  .section-title-icon button {
    height: auto;
    padding: 8px;
  }
  .section-title-info {
    flex: 0 0 80%;
    text-align: left;
  }
}

@media screen and (min-width: 657px) and (max-width: 807px) {
  .section-title-info,
  .section-title-internal .section-title-info {
    flex: 0 0 75% !important;
    text-align: center;
  }
  .section-title-btn-help,
  .section-title-internal .section-title-btn-help {
    flex: 0 0 12% !important;
  }
  .section-title-icon button,
  .section-title-btn-help button,
  .section-title.section-title-internal .section-title-icon button {
    font-size: 10px !important;
  }
  .section-title-info h4,
  .section-title.section-title-internal .section-title-info h4 {
    font-size: 18px !important;
  }
  .section-title-info p,
  .section-title.section-title-internal .section-title-info p {
    font-size: 12px !important;
  }
}

@media screen and (min-width: 808px) and (max-width: 1023px) {
  .section-title-info,
  .section-title-internal .section-title-info {
    flex: 0 0 75% !important;
    text-align: center;
  }
  .section-title-btn-help,
  .section-title-internal .section-title-btn-help {
    flex: 0 0 12% !important;
  }
  .section-title-icon button,
  .section-title-btn-help button,
  .section-title.section-title-internal .section-title-icon button {
    font-size: 10px !important;
  }
  .section-title-info h4,
  .section-title.section-title-internal .section-title-info h4 {
    font-size: 18px !important;
  }
  .section-title-info p,
  .section-title.section-title-internal .section-title-info p {
    font-size: 12px !important;
  }
}

@media screen and (min-width: 1024px) and (max-width: 1265px) {
}
</style>
